<script setup lang="ts">
/**
 * What a card group shows when it has nothing yet: one line saying what is missing,
 * one line saying what to do, and the action that does it. Never an illustration.
 */
import Icon from './Icon.vue'
withDefaults(defineProps<{ title?: string; hint?: string; compact?: boolean }>(), {
  title: 'No data to display',
  hint: undefined,
})
</script>

<template>
  <div
    data-empty-state role="status"
    class="flex min-w-0 flex-col items-center justify-center gap-2 px-3 text-center"
    :class="compact ? 'min-h-[var(--empty-state-compact-min-height)] py-3' : 'min-h-[var(--empty-state-min-height)] py-6'"
  >
    <span class="text-muted-foreground [&_svg]:size-4"><slot name="icon"><Icon name="table" :size="16" /></slot></span>
    <span class="text-xs font-semibold">{{ title }}</span>
    <span v-if="hint" class="num max-w-[var(--measure-420px)] text-[length:var(--type-meta)] leading-relaxed text-muted-foreground text-pretty">{{ hint }}</span>
    <div v-if="$slots.action" class="mt-1 flex items-center gap-2.5"><slot name="action" /></div>
  </div>
</template>
